export default "__VITE_ASSET__a0c9bd28__"